import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';
import { AppDispatch } from 'src/redux/store';

export const fetchAllChallengeTagsRequest = createAction('fetchAllChallengeTagsRequest');
export const fetchAllChallengeTagsSuccess = createAction<ChallengeTag[]>(
    'fetchAllChallengeTagsSuccess',
);
export const fetchAllChallengeTagsFailure = createAction('fetchAllChallengeTagsFailure');

export const fetchAllChallengeTags = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAllChallengeTagsRequest());
    try {
        const { data } = await api.get<ChallengeTag[]>('admin/challengeTags');
        dispatch(fetchAllChallengeTagsSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAllChallengeTagsFailure, e);
    }
};
